module.exports = __webpack_public_path__ + "img/93974.5d94e35a.svg";